export default function Tag(props: any) {
    const colorCodes: any = {
        red: {
            bgColor: "#FFE9E9F3",
            textColor: "#AC1946",
            borderColor: "#AC1946",
        },
        green: {
            bgColor: "#DCFFE0",
            textColor: "#008D10",
            borderColor: "#008D10",
        },
        yellow: {
            bgColor: "#FDF2DC",
            textColor: "#845201",
            borderColor: "#845201",
        },
        pink: {
            bgColor: "#F4E5EF",
            textColor: "#A91A90",
            borderColor: "#A91A90",
        },
        grey: {
            bgColor: "#F3F3F3F3",
            textColor: "#5E5E5E",
            borderColor: "#E8E8E8",
        },
        grey2: {
            bgColor: "#F3F3F3",
            textColor: "#4B4B4B",
            borderColor: "#E8E8E8",
        },

        dark_grey_theme1:{
            bgColor: "var(--gray-color26)",
            textColor: "var(--white-color)",
            borderColor: "var(--gray-color26)",
        },
        dark_red_theme1: {
            bgColor: "var(--red-color6)",
            textColor: "var(--red-color8)",
            borderColor: "var(--red-color7)",
        },
        dark_grey2_theme1: {
            bgColor: "var(--gray-color27)",
            textColor: "var(--white-color11)",
            borderColor: "var(--white-color11)",
        },
    }
    return (
        <div
            className='flex items-center'
            style={{
                width : props.myWidth || "",
                background: colorCodes[props.colorCode]['bgColor'],
                color: colorCodes[props.colorCode]['textColor'],
                fontSize: props.textSize,
                borderTopLeftRadius: props.borderR_tl || "0px",
                borderTopRightRadius: props.borderR_tr || "0px",
                borderBottomLeftRadius: props.borderR_bl || "0px",
                borderBottomRightRadius: props.borderR_br || "0px",
                border: props.borderWidth ? `${props.borderWidth} solid ${colorCodes[props.colorCode]['borderColor']}` : '',
                boxShadow: props.setBoxShow || '',
                paddingLeft: props.padding_left || "6px",
                paddingTop: props.padding_top || "5px",
                paddingRight: props.padding_right || "6px",
                paddingBottom: props.padding_bottom || "5px",
                fontWeight: props.textWeight || 400,
            }}
        >
            {props.icon &&
                <img
                    style={{
                        width: props.iconWidth
                    }}
                    className='mr-[5px]'
                    src={props.icon} alt='tagIcon' />
            }

            <p
                style={{
                    lineHeight: props.line_hight || "10px",
                }}
                className='truncate max-w-full'>
                {props.text}
            </p>

        </div>
    );
}
